var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.459,
    height: 29.122,
    viewBox: "0 0 23.459 29.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-upload-icon",
    transform: "translate(-1 511.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379123",
    "data-name": "Path 379123",
    d: "M2.1-511.89a1.881,1.881,0,0,0-.905.7l-.171.279-.017,13.472L1-483.967l.142.3a1.55,1.55,0,0,0,.735.717l.233.125H23.349l.3-.165a1.632,1.632,0,0,0,.729-.82c.063-.171.074-2,.08-9.617v-9.407l-.467-.5c-.262-.279-2.181-2.3-4.271-4.493-2.688-2.83-3.849-4.014-3.98-4.06C15.514-511.97,2.378-511.97,2.1-511.89Zm12.459,5.711c.017,3.946.017,4.014.137,4.174a1.211,1.211,0,0,0,.364.285l.251.131h7.436v17.025H2.708v-25.623H14.552Zm3.952-.382c1.184,1.247,2.357,2.477,2.608,2.733l.456.473H16.317v-2.733c0-1.5.011-2.733.023-2.733S17.331-507.8,18.515-506.561Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379124",
    "data-name": "Path 379124",
    d: "M156.757-280.89a32.286,32.286,0,0,0-2.6,2.984.631.631,0,0,0,.017.626.772.772,0,0,0,1.042.33,4.007,4.007,0,0,0,.609-.6l.444-.524.028,1.873c.028,1.7.04,1.89.137,2.05a.735.735,0,0,0,.683.364.561.561,0,0,0,.456-.177.959.959,0,0,0,.262-.382,19.671,19.671,0,0,0,.057-2l.006-1.794.5.524c.547.575.649.643.951.643a.707.707,0,0,0,.661-.444.7.7,0,0,0-.137-.854c-.791-.917-2.357-2.591-2.471-2.636A.892.892,0,0,0,156.757-280.89Z",
    transform: "translate(-144.369 -217.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379125",
    "data-name": "Path 379125",
    d: "M101.944-169.471c-.427.2-.444.273-.444,1.97,0,1.646.006,1.68.387,1.908.177.108.33.114,5.62.114s5.444-.006,5.62-.114c.382-.228.387-.262.387-1.908,0-1.708-.017-1.777-.461-1.97a.684.684,0,0,0-.843.148c-.239.239-.262.364-.262,1.429v.877h-8.871l-.023-1.014c-.017-.86-.034-1.031-.12-1.162A.764.764,0,0,0,101.944-169.471Z",
    transform: "translate(-94.777 -322.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.f998eab036daade6ec3985447262c8f4.svg";
export { ForwardRef as ReactComponent };